import React from 'react';
import RegistrationOnlyAlert from '../components/FormAlerts/RegistrationOnlyAlert';
import FormFooter from '../components/FormFooter';
import { useRouteFocusOnLoad } from '../hooks/useRouteFocusOnLoad';

const AuthRegistrationOnlyPage = () => {
  useRouteFocusOnLoad('va-alert h1');

  return (
    <>
      <div className="progress-box progress-box-schemaform vads-u-padding-x--0">
        <div className="vads-u-margin-y--2 form-panel">
          <RegistrationOnlyAlert />
        </div>
      </div>
      <FormFooter />
    </>
  );
};

export default AuthRegistrationOnlyPage;
